import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useServiceCenterSettings } from "./hooks/useServiceCenterSettings";

function MetaUpdater() {
  const { latestOrderTime, earliestReturnTime } = useServiceCenterSettings();

  useEffect(() => {
    if (!latestOrderTime || !earliestReturnTime) return;

    const title = `Klosters Ski-Service Kurier | Bestellen bis ${latestOrderTime} • Rückgabe ${earliestReturnTime}`;
    const description = `Professioneller Ski-Service Kurier mit Abholung am Abend und Rückgabe am Morgen (${earliestReturnTime}). Wachsen, Schleifen, Reparatur in Davos, Klosters und Arosa. Perfekt präparierte Ski über Nacht.`;
    const ogDesc = `Wir holen deine Ski am Abend ab, führen einen professionellen Service durch und bringen sie bis ${earliestReturnTime} Uhr perfekt präpariert zurück.`;

    document.title = title;

    const setMeta = (selector: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", value);
    };

    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', ogDesc);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', ogDesc);
  }, [latestOrderTime, earliestReturnTime]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <MetaUpdater />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
